__turbopack_context__.v({
  "arrow": "styles-module-scss-module__44RxUa__arrow",
  "desktopCarouselContent": "styles-module-scss-module__44RxUa__desktopCarouselContent",
  "desktopCompact": "styles-module-scss-module__44RxUa__desktopCompact",
  "imageAlignedNav": "styles-module-scss-module__44RxUa__imageAlignedNav",
  "itemCarousel": "styles-module-scss-module__44RxUa__itemCarousel",
  "itemContainer": "styles-module-scss-module__44RxUa__itemContainer",
  "itemLink": "styles-module-scss-module__44RxUa__itemLink",
  "mobileCarouselContent": "styles-module-scss-module__44RxUa__mobileCarouselContent",
  "mobileGridPage": "styles-module-scss-module__44RxUa__mobileGridPage",
  "seeMoreCard": "styles-module-scss-module__44RxUa__seeMoreCard",
  "seeMoreContent": "styles-module-scss-module__44RxUa__seeMoreContent",
  "seeMoreDescription": "styles-module-scss-module__44RxUa__seeMoreDescription",
  "seeMoreText": "styles-module-scss-module__44RxUa__seeMoreText",
});
